// "use client"

// import { useRef } from "react"
// import { motion, useInView } from "framer-motion"
// import { FileText, PenTool, BarChart2, Zap, CheckCircle, Users } from "lucide-react"

// const processSteps = [
//   {
//     icon: <FileText className="w-8 h-8" />,
//     title: "Discovery & Planning",
//     description:
//       "We start by understanding your business, audience, and reporting goals to create a tailored strategy.",
//     number: "01",
//   },
//   {
//     icon: <PenTool className="w-8 h-8" />,
//     title: "Content Development",
//     description:
//       "Our content specialists craft compelling narratives that transform complex data into engaging stories.",
//     number: "02",
//   },
//   {
//     icon: <BarChart2 className="w-8 h-8" />,
//     title: "Data Visualization",
//     description: "We create intuitive charts, graphs, and infographics that make your data accessible and impactful.",
//     number: "03",
//   },
//   {
//     icon: <Users className="w-8 h-8" />,
//     title: "Design & Layout",
//     description:
//       "Our designers develop visually stunning layouts that align with your brand identity and enhance readability.",
//     number: "04",
//   },
//   {
//     icon: <Zap className="w-8 h-8" />,
//     title: "Review & Refinement",
//     description: "We collaborate closely with you to refine the report until it perfectly meets your expectations.",
//     number: "05",
//   },
//   {
//     icon: <CheckCircle className="w-8 h-8" />,
//     title: "Delivery & Support",
//     description: "We deliver your finalized reports in all required formats with ongoing support for any adjustments.",
//     number: "06",
//   },
// ]

// export default function ProcessSection() {
//   const sectionRef = useRef<HTMLDivElement>(null)
//   const isInView = useInView(sectionRef, { once: false, amount: 0.2, margin: "-100px" })

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//       },
//     },
//   }

//   const itemVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.6, ease: "easeOut" },
//     },
//   }

//   return (
//     <section ref={sectionRef} className="py-20 md:py-32 bg-gray-100 relative overflow-hidden" id="process">
//       <div className="container mx-auto px-4 relative z-10">
//         <motion.div
//           initial="hidden"
//           animate={isInView ? "visible" : "hidden"}
//           variants={containerVariants}
//           className="text-center mb-16"
//         >
//           <motion.span
//             variants={itemVariants}
//             className="inline-block mb-4 px-4 py-1 rounded-full bg-gray-200 text-gray-800 font-medium text-sm"
//           >
//             Our Process
//           </motion.span>

//           <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//             How We Create Premium Reports
//           </motion.h2>

//           <motion.p variants={itemVariants} className="text-lg text-gray-600 max-w-3xl mx-auto">
//             We follow a structured approach to create reports that effectively communicate your company's story and
//             engage your stakeholders.
//           </motion.p>
//         </motion.div>

//         {/* Timeline Process */}
//         <div className="relative max-w-5xl mx-auto">
//           {/* Vertical line */}
//           <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-gray-300 transform md:translate-x-[-0.5px]"></div>

//           {processSteps.map((step, index) => (
//             <motion.div
//               key={index}
//               initial="hidden"
//               animate={isInView ? "visible" : "hidden"}
//               variants={itemVariants}
//               className={`relative mb-16 last:mb-0 md:flex ${index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
//             >
//               {/* Timeline dot */}
//               <div className="absolute left-0 md:left-1/2 top-0 w-8 h-8 bg-white rounded-full border-4 border-gray-800 transform translate-x-[-14px] md:translate-x-[-14px] z-10"></div>

//               {/* Content */}
//               <div className={`md:w-1/2 ${index % 2 === 0 ? "md:pr-12" : "md:pl-12"}`}>
//                 <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-200">
//                   <div className={`flex items-center mb-4 gap-3 ${index % 2 === 0 ? "justify-end" : "justify-start"}`}>
//                     <div className={`${index % 2 === 0 ? "order-2" : ""}`}>
//                       <div className="text-xl font-bold text-gray-800 bg-gray-100 px-3 py-1 rounded-lg">
//                         {step.number}
//                       </div>
//                     </div>
//                     <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
//                   </div>

//                   <p className={`text-gray-600 ${index % 2 === 0 ? "text-right" : "text-left"}`}>{step.description}</p>

//                   <div className={`mt-4 flex ${index % 2 === 0 ? "justify-end" : "justify-start"}`}>
//                     <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-800">
//                       {step.icon}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         <motion.div
//           variants={itemVariants}
//           initial="hidden"
//           animate={isInView ? "visible" : "hidden"}
//           className="mt-16 text-center"
//         >
//           <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-8">
//             Ready to transform your corporate reporting with our expert design services?
//           </p>
//           <motion.button
//             className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg transition-all duration-300"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//           >
//             Start Your Project
//           </motion.button>
//         </motion.div>
//       </div>
//     </section>
//   )
// }







































"use client"

import { useRef } from "react"
import { motion, useInView } from "framer-motion"
import { FileText, PenTool, BarChart2, Zap, CheckCircle, Users } from "lucide-react"
import Link from "next/link"

const processSteps = [
  {
    icon: <FileText className="w-8 h-8" />,
    title: "Discovery & Planning",
    description:
      "We start by understanding your business, audience, and reporting goals to create a tailored strategy.",
    number: "01",
  },
  {
    icon: <PenTool className="w-8 h-8" />,
    title: "Content Development",
    description:
      "Our content specialists craft compelling narratives that transform complex data into engaging stories.",
    number: "02",
  },
  {
    icon: <BarChart2 className="w-8 h-8" />,
    title: "Data Visualization",
    description: "We create intuitive charts, graphs, and infographics that make your data accessible and impactful.",
    number: "03",
  },
  {
    icon: <Users className="w-8 h-8" />,
    title: "Design & Layout",
    description:
      "Our designers develop visually stunning layouts that align with your brand identity and enhance readability.",
    number: "04",
  },
  {
    icon: <Zap className="w-8 h-8" />,
    title: "Review & Refinement",
    description: "We collaborate closely with you to refine the report until it perfectly meets your expectations.",
    number: "05",
  },
  {
    icon: <CheckCircle className="w-8 h-8" />,
    title: "Delivery & Support",
    description: "We deliver your finalized reports in all required formats with ongoing support for any adjustments.",
    number: "06",
  },
]

export default function ProcessSection() {
  const sectionRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(sectionRef, { once: false, amount: 0.2, margin: "-100px" })

  const containerVariants = {
    hidden: { opacity: 100 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 100, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  }

  return (
    <section ref={sectionRef} className="md:py-20 py-16 bg-gray-100 relative overflow-hidden" id="process">
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-16"
        >
          {/* <motion.h2
            variants={itemVariants}
            className="inline-block mb-4 px-4 py-2 rounded-full bg-gray-200 text-gray-800 font-medium text-sm"
          >
            Our Process
          </motion.h2> */}

          <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Process to Design Corporate Sustainability Reports
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg text-gray-600 max-w-3xl mx-auto">
            We follow a structured approach to create reports that effectively communicate your company's story and
            engage your stakeholders.
          </motion.p>
        </motion.div>

        {/* Timeline Process */}
        <div className="relative max-w-5xl mx-auto">
          {/* Vertical line */}
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-gray-300 transform md:translate-x-[-0.5px]"></div>

          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={itemVariants}
              className={`relative mb-16 last:mb-0 md:flex ${index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
            >
              {/* Timeline dot */}
              <div className="absolute left-0 md:left-1/2 top-0 w-8 h-8 bg-white rounded-full border-4 border-gray-800 transform translate-x-[-14px] md:translate-x-[-14px] z-10"></div>

              {/* Content */}
              <div className={`md:w-1/2 ${index % 2 === 0 ? "md:pr-12" : "md:pl-12"}`}>
                <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-200">
                  <div className={`flex items-center mb-4 gap-3 ${index % 2 === 0 ? "justify-end" : "justify-start"}`}>
                    <div className={`${index % 2 === 0 ? "order-2" : ""}`}>
                      <div className="text-xl font-bold text-gray-800 bg-gray-100 px-3 py-1 rounded-lg">
                        {step.number}
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  </div>

                  <p className={`text-gray-600 ${index % 2 === 0 ? "text-right" : "text-left"}`}>{step.description}</p>

                  <div className={`mt-4 flex ${index % 2 === 0 ? "justify-end" : "justify-start"}`}>
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-800">
                      {step.icon}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          variants={itemVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="mt-16 text-center"
        >
          <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-8">
            Ready to transform your corporate reporting with our expert design services?
          </p>
          <Link href="#contact" className="inline-block">
          <motion.button
            className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg transition-all duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Start Your Project
          </motion.button>
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
